import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Browser } from "@capacitor/browser";
import Logo from "../components/Logo";
import { auth } from "../api/client";
import { IS_NATIVE, NATIVE_OIDC_RETURN_TO } from "../lib/native";

export default function LoginPage() {
  const [params] = useSearchParams();
  const returnTo = params.get("return_to") || "/";
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    auth.oauthInfo()
      .then(async (info) => {
        if (cancelled) return;
        if (!info?.enabled) {
          setError("Anmeldung gerade nicht erreichbar.");
          return;
        }
        if (IS_NATIVE) {
          // On Android, open Keycloak in the system browser tab. The deep-link
          // handler in `lib/native.ts` consumes the returned tokens.
          const url = auth.oauthLoginUrl(NATIVE_OIDC_RETURN_TO);
          await Browser.open({ url, presentationStyle: "fullscreen" });
        } else {
          window.location.replace(
            auth.oauthLoginUrl(`${window.location.origin}${returnTo}`),
          );
        }
      })
      .catch(() => {
        if (!cancelled) setError("Anmeldung gerade nicht erreichbar.");
      });
    return () => {
      cancelled = true;
    };
  }, [returnTo]);

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-gradient-to-br from-ink-950 via-ink-900 to-brand-950">
      <div className="w-full max-w-sm text-center">
        <span className="inline-grid h-14 w-14 mx-auto place-items-center rounded-2xl bg-brand-500 text-ink-950 shadow-lg">
          <Logo size={32} />
        </span>
        <h1 className="mt-4 text-2xl font-semibold text-ink-50">Logbuch</h1>
        {error ? (
          <p
            role="alert"
            className="mt-6 text-sm text-bad-500 bg-bad-500/10 rounded-md px-3 py-2 ring-1 ring-inset ring-bad-500/30"
          >
            {error}
          </p>
        ) : (
          <p className="mt-6 text-sm text-ink-400">Weiterleitung zur Anmeldung …</p>
        )}
      </div>
    </div>
  );
}
